export default __webpack_public_path__ + "static/media/mobile_dark.91481c66.svg";